import {
    getUrlParam,
    handleRequest,
    isIOS,
    arrayBufferToBase64,
    parseBinaryToJson,
    buryMd5Sign
} from '@/utils/tool.js';
import { requestLogSLS, sendRequestLogSLS, send } from '@/utils/sls';
import native from '@/utils/native';

import axios from 'axios';
import store from '@/store/index';
import { Dialog } from 'vant';
import 'vant/es/toast/style';
const env = process.env.envMode || process.env.NODE_ENV;
console.log(env, 'env');
let deviceIdString;
let deviceId = '';
let getAppVersion = '';
let appVersion = '';
const NODE_ENV = process.env.NODE_ENV;
// let host = window.location.host;

try {
    deviceIdString = window.navigator.userAgent.match(/pid\/([0-9A-Fa-f-]+)/);
    getAppVersion = window.navigator.userAgent.match(/appVersion\/([0-9A-Fa-f-]+)/);
    if (deviceIdString) {
        deviceId = deviceIdString[0] && deviceIdString[0].replace('pid/', '');
        deviceId = deviceId || getUrlParam('userID');
    } else {
        deviceId = getUrlParam('userID');
    }
    if (getAppVersion && NODE_ENV !== 'development') {
        appVersion = getAppVersion[1];
    }
} catch (e) {
    console.error(e);
}
// 版本号大于5019000的才使用app签名和加密
const enableAppVersion = appVersion && /^\d+$/.test(appVersion) && appVersion - 0 >= 5019000;
// 加密开关
let isSecret = true;
// 是否调用接口获取加密开关
let hasGetSecretInterface = false;
const getProjectSecret = async () => {
    const timeMs = Date.now();
    const data = {
        dataId: 'preject-secret-switch',
        group: 'skrweb',
        namespaceId: 'namespace_web',
        timeMs,
        apiSecret: 'skr2020'
    };
    const postData = {
        dataId: 'preject-secret-switch',
        group: 'skrweb',
        namespaceId: 'namespace_web',
        timeMs,
        sign: buryMd5Sign(data)
    };
    try {
        const res = await axios.post('/v1/kconf/config', postData);
        const content = JSON.parse(res.data.data?.content || '');
        isSecret = content?.isSecret && true;
    } catch (err) {
        console.log(err);
        send({
            type: 'getProjectSecret',
            data: err
        });
        return false;
    } finally {
        hasGetSecretInterface = true;
    }
};

const retryDecode = (baseEncodeStr) => {
    return new Promise((resolve, reject) => {
        setTimeout(async () => {
            try {
                const decodeData = await native.decodeData({
                    contentBase64: baseEncodeStr,
                    timeStamp: 0,
                    MIMEType: 'application/ensr2'
                });
                console.log('====ios 解密重试====');
                resolve(decodeData);
            } catch (error) {
                send({
                    type: 'retryDecode',
                    data: error
                });
                reject(error);
            }
        }, 2000);
    });
};

const faceVerification = (res) => {
    // 需要拦截的请求
    const arr = ['/v2/honor/wx-order', '/v2/xpay/iap-order', '/v2/honor/ali-order'];

    const url = res.config.url;
    const errno = res.data.errno;
    if (arr.includes(url) && errno === 8360039) {
        Dialog.alert({
            message: '尊敬的用户您好，为了保证您的账户安全，需完成实名认证，感谢您的理解与支持',
            confirmButtonText: '去认证',
            confirmButtonColor: '#1989fa'
        }).then(() => {
            window.location.href =
                'inframeskr://web/fullScreen?showType=0&newURL=https%3A%2F%2Fapp.inframe.mobi%2Foauth%2Fv2%2F%3Ftitle%3D1%26scene%3D33';
        });
    }
};

if (NODE_ENV === 'development') {
    axios.defaults.headers['Inframe-Query-Sign-Disable'] = '1';
}
axios.defaults.headers['Content-Type'] = 'application/json; charset=UTF-8';
axios.defaults.headers['Inframe-Client-ID'] = deviceId;
axios.defaults.headers['Inframe-App-Version'] = appVersion;
axios.defaults.headers['Inframe-Query-Web'] = appVersion ? '100' : '200';
if (env === 'development') {
    axios.defaults.headers['Inframe-Query-Sign-Disable'] = '1';
}
console.log('appVersion', appVersion);
export default function request(options, isShowLoading = true, controlLoading = true) {
    return new Promise((resolve, reject) => {
        // 创建axios实例
        const service = axios.create({
            // axios中请求配置有baseURL选项，表示请求URL公共部分
            baseURL: process.env.VUE_APP_baseUrl, //baseURL 将会被加在 url 前面。
            // 超时
            timeout: 20000,
            withCredentials: true // 是否允许带cookie这些
        });
        // request拦截器
        service.interceptors.request.use(
            async (config) => {
                controlLoading && store.commit('common/updateLoading', isShowLoading);
                const params = {
                    m: config.method.toUpperCase(),
                    p: config.url,
                    q: '',
                    b: '',
                    t: '5'
                };
                switch (config.method) {
                    case 'get':
                        config.params = config.params; // eslint-disable-line
                        if (
                            typeof config.params === 'object' &&
                            Object.keys(config.params).length > 0
                        ) {
                            let str = '';
                            for (let key in config.params) {
                                const value = config.params[key];
                                if (str) {
                                    if (value && Array.isArray(value)) {
                                        value.forEach((val) => {
                                            str += `&${key}[]=${val}`;
                                        });
                                    } else {
                                        str += `&${key}=${value}`;
                                    }
                                } else {
                                    if (value && Array.isArray(value)) {
                                        value.forEach((val) => {
                                            if (!str) {
                                                str += `${key}[]=${val}`;
                                            } else {
                                                str += `&${key}[]=${val}`;
                                            }
                                        });
                                    } else {
                                        str += `${key}=${value}`;
                                    }
                                }
                            }
                            params.q = str || '';
                        }
                        break;
                    case 'post':
                        config.headers['Content-Type'] = 'application/json; charset=UTF-8'; // application/x-www-form-urlencoded; charset=UTF-8
                        // config.data = qs.stringify(config.data);
                        break;
                    default:
                }
                if (config.method !== 'get') {
                    params.q = '';
                    params.b = JSON.stringify(config.data) || '';
                }
                !hasGetSecretInterface && (await getProjectSecret());
                // ios使用bridge签名/加密 5017000
                if (enableAppVersion && isIOS()) {
                    try {
                        const re = await handleRequest(params);
                        // 接口加密配置
                        if (isSecret) {
                            config.headers['Accept'] = 'application/ensr2';
                            config.responseType = 'arraybuffer';
                        }

                        if (!re) {
                            return config;
                        }
                        const { s, t } = re || {};
                        if (!s || !t) {
                            return config;
                        }
                        if (t) {
                            config.headers['Inframe-Query-TKey'] = t || '';
                        }
                        if (s) {
                            config.headers['Inframe-Query-Sign5'] = s || '';
                            config.headers['Inframe-Query-Source'] = '10';
                        }
                        return config;
                    } catch (err) {
                        send({
                            type: 'ios使用bridge签名/加密 5017000',
                            data: err
                        });
                        return config;
                    }
                }
                // 安卓使用请求拦截方式签名加密
                if (enableAppVersion && !isIOS()) {
                    console.log('安卓签名加密', isSecret);
                    // 接口加密配置
                    config.headers['C-Sign'] = 1;
                    if (isSecret) {
                        config.headers['Accept'] = 'application/ensr2';
                    }
                    // 接口签名配置
                    if (config.method === 'post' || config.method === 'put') {
                        const originalString = JSON.stringify(config.data) || '';
                        const utf8String = encodeURIComponent(originalString);
                        const base64String = btoa(utf8String);
                        config.headers['C-Body'] = base64String;
                    }
                }
                return config;
            },
            (error) => {
                store.commit('common/updateLoading', false);
                Promise.reject(error);
            } // 请求拦截器的报错处理
        );

        // 响应拦截器
        service.interceptors.response.use(
            async (res) => {
                const contentType = res.headers['content-type'];
                // 接口加密
                if (enableAppVersion && isIOS() && contentType === 'application/ensr2') {
                    const encodeStr = res.data;
                    const baseEncodeStr = arrayBufferToBase64(encodeStr);
                    try {
                        let decodeData = await native.decodeData({
                            contentBase64: baseEncodeStr,
                            timeStamp: 0,
                            MIMEType: 'application/ensr2'
                        });
                        if (!decodeData || !decodeData.JSONContent) {
                            decodeData = await retryDecode(baseEncodeStr);
                        }
                        if (decodeData && decodeData.JSONContent) {
                            try {
                                const content = JSON.parse(decodeData.JSONContent) || {};
                                faceVerification({ ...res, data: content });
                                if (content?.errno || !content) {
                                    sendRequestLogSLS({ ...res, data: content });
                                    reject(content || {});
                                } else {
                                    requestLogSLS({ ...res, data: content });
                                    resolve(content || {});
                                }
                            } catch (error) {
                                sendRequestLogSLS(res);
                                console.log('error', error);
                            }
                        }
                    } catch (error) {
                        sendRequestLogSLS(res);
                        reject(error);
                        console.log('error', error);
                    }
                } else {
                    faceVerification(res);
                    let resObj = res.data;
                    if (enableAppVersion && isIOS() && isSecret) {
                        try {
                            resObj = parseBinaryToJson(res.data);
                        } catch (error) {
                            console.log('error', error);
                            sendRequestLogSLS(res);
                            reject(error);
                        }
                    }
                    const handleErrCode = resObj.errno;
                    if (!handleErrCode) {
                        requestLogSLS(res);
                        resolve(resObj);
                    } else {
                        sendRequestLogSLS(res);
                        reject(resObj);
                    }
                }
                controlLoading && store.commit('common/updateLoading', false);
            },
            (error) => {
                sendRequestLogSLS({ error });
                console.log('err' + error);
                controlLoading && store.commit('common/updateLoading', false);
                let { message } = error;
                if (message == 'Network Error') {
                    message = '网络异常，请检查网络';
                } else if (message.includes('timeout')) {
                    message = '系统接口请求超时，请检查网络';
                } else if (message.includes('Request failed with status code')) {
                    message = `系统接口${message.substr(message.length - 3)}异常`;
                }
                // Toast(message);
                error.errmsg = message;
                Dialog.confirm({
                    message,
                    cancelButtonText: '退出',
                    cancelButtonColor: '#ee0a24',
                    confirmButtonText: '重新加载',
                    confirmButtonColor: '#1989fa'
                })
                    .then(() => {
                        window.location.reload();
                    })
                    .catch(() => {
                        native.closePage({});
                    });
                // return reject(error);
                return;
            }
        );
        service(options);
    });
}
